import { Validators } from '@angular/forms';

export const FieldValidators = {
  personName: [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-Z\s]+$/)],
  personNameOptional: [Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-Z\s]+$/)],
  email: [Validators.required, Validators.email],
  emailOptional: [Validators.email],
  mobile10: [Validators.required, Validators.pattern(/^[0-9]{10}$/), Validators.minLength(10), Validators.maxLength(10)],
  mobile10Optional: [Validators.pattern(/^[0-9]{10}$/), Validators.minLength(10), Validators.maxLength(10)],
  alphanumericText: [Validators.required, Validators.minLength(2), Validators.pattern(/^[a-zA-Z0-9\s\.,\-&'()]+$/)],
  alphanumericTextOptional: [Validators.pattern(/^[a-zA-Z0-9\s\.,\-&'()]+$/)],
  schoolName: [Validators.required, Validators.pattern(/^[a-zA-Z\s\.\,\`\']+$/)],
  cityName: [Validators.required, Validators.pattern(/^[a-zA-Z\s,\-]+$/)],
  description500: [Validators.required, Validators.maxLength(500)],
  optionalMax500: [Validators.maxLength(500)],
  yearField: [Validators.required, Validators.pattern(/^\d{4}$/)],
  percentageScore: [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(0), Validators.max(100)],
  testScore: [Validators.pattern(/^[0-9]+(\.[0-9]+)?$/)],
  requiredOnly: [Validators.required]
};
